import { Routes } from '@angular/router'
import { MainLayoutComponent } from "./core/layout/components/main-layout/main-layout.component";
import { NotFoundComponent } from "./core/error-handling/components/not-found/not-found.component";

export const appRoutes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: 'home', redirectTo: '', pathMatch: 'full' },
      {
        path: '',
        loadComponent: () => import('./features/landing-page/landing-page.component').then(m => m.LandingPageComponent),
        title: 'Home'
      },
      {
        path: 'tools',
        loadChildren: () => import('./features/tools/tools.routes'),
        title: 'Tools',
      },
      {
        path: 'demos',
        loadChildren: () => import('./features/demos/demos.routes'),
        title: 'Demos',
      },
    ]
  },
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.routes'),
  },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: '/not-found' }
];
